export default {
  path: '/complaintManage',
  auth: false,
  preload: false,
  isStatic: true,
  key: 'complaintManage',
  component: () => import('./index')
};
